import * as tslib_1 from "tslib";
import { EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { DeadlinesContractsMapper } from 'app/main/settings/registers/deadlines-contracts/mappers/deadlines-contracts.mapper';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import english from '../../../../i18n/en.json';
import spanish from '../../../../i18n/es.json';
import portuguese from '../../../../i18n/pt.json';
var TabNewDeadlineComponent = /** @class */ (function () {
    function TabNewDeadlineComponent(data, fuseTranslationLoaderService, formBuilder) {
        this.data = data;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.formBuilder = formBuilder;
        this.customInterval = [];
        this.subscriptions = new Subject();
        this.isAllowToEditResponseViolationReason = false;
        this.isAllowToEditSolutionViolationReason = false;
        this.getDeadlinesForm = new EventEmitter();
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.customInterval = [];
        this.maintenance = data.maintenance;
        this.maintenanceDeadlineContract = data.maintenance.deadlineContract;
        this.newDeadlineForm = this.formBuilder.group({
            responseDeadlineViolationReason: [null],
            solutionDeadlineViolationReason: [null],
        });
    }
    TabNewDeadlineComponent.prototype.ngOnInit = function () {
        var e_1, _a;
        var _this = this;
        var currentCustomInterval = this.maintenanceDeadlineContract && this.maintenanceDeadlineContract.customInterval;
        if (currentCustomInterval) {
            try {
                for (var _b = tslib_1.__values(Object.values(DeadlinesContractsMapper.daysOfWeek)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var day = _c.value;
                    var value = currentCustomInterval[day];
                    this.customInterval.push({
                        day: day.toUpperCase(),
                        start: value && value.start && DeadlinesContractsMapper.toTimeWithTimezone(value.start),
                        end: value && value.end && DeadlinesContractsMapper.toTimeWithTimezone(value.end),
                    });
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        if (this.maintenanceDeadlineContract) {
            var _d = this.maintenanceDeadlineContract, responseDeadlineViolationReason = _d.responseDeadlineViolationReason, solutionDeadlineViolationReason = _d.solutionDeadlineViolationReason;
            if (responseDeadlineViolationReason) {
                this.newDeadlineForm.get('responseDeadlineViolationReason').setValue(responseDeadlineViolationReason.deadlineViolationReason);
            }
            if (solutionDeadlineViolationReason) {
                this.newDeadlineForm.get('solutionDeadlineViolationReason').setValue(solutionDeadlineViolationReason.deadlineViolationReason);
            }
            var isResponseDeadlineViolatedOrCompletedWithViolation = ['violated', 'completedWithViolation'].includes(this.maintenance.responseDeadlineStatus);
            var isSolutionDeadlineViolatedOrCompletedWithViolation = ['violated', 'completedWithViolation'].includes(this.maintenance.solutionDeadlineStatus);
            this.isAllowToEditResponseViolationReason = isResponseDeadlineViolatedOrCompletedWithViolation && (!responseDeadlineViolationReason || responseDeadlineViolationReason.linkedBy === 'enterprise');
            this.isAllowToEditSolutionViolationReason = isSolutionDeadlineViolatedOrCompletedWithViolation && (!solutionDeadlineViolationReason || solutionDeadlineViolationReason.linkedBy === 'enterprise');
        }
        this.newDeadlineForm.valueChanges
            .pipe(takeUntil(this.subscriptions))
            .subscribe(function () {
            _this.getDeadlinesForm.emit(_this.newDeadlineForm);
        });
        this.getDeadlinesForm.emit(this.newDeadlineForm);
    };
    TabNewDeadlineComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.next();
        this.subscriptions.complete();
    };
    return TabNewDeadlineComponent;
}());
export { TabNewDeadlineComponent };
